import styled, { withTheme } from 'styled-components'
import { Box } from 'rebass'
import typography from '../../../utils/typography'

const ColumnImage = styled(Box)`
  text-align: center;
  img,
  svg {
    position: relative;
    display: block;
    margin: 0 auto;
    max-height: ${typography.rhythm(0.8)};
  }
`

export default withTheme(ColumnImage)
